export const endPoints = {
  STATE_SALES: '/v1/mobile/stat-sales'
};
